import React from 'react';
import PropTypes from 'prop-types';

import { Label, FormGroup } from '@sopranodesign/pulse-components';
import { TemplatingTextArea } from '@sopranodesign/pulse-templating';

import { useComposer } from '../../../../hooks/index';
import { ButtonComposer } from '../../../Buttons/index';

const ActionInput = ({
  rtl = 'ltr'
}) => {
  const {
    response: { content },
    dispatch
  } = useComposer();

  const handleResponseChange = value => {
    dispatch({
      type: 'UPDATE_CONTENT',
      newContent: { text: value, responses: content.responses }
    });
  };

  const handleResponsesChange = responses => {
    dispatch({
      type: 'UPDATE_CONTENT',
      newContent: { text: content.text, responses }
    });
  };

  return (
    <div>
      <FormGroup>
        <Label htmlFor="action">Message</Label>
        <TemplatingTextArea
          rtl={rtl}
          id="action"
          name="action"
          value={content.text}
          onChange={handleResponseChange}
        />
      </FormGroup>
      <ButtonComposer
        rtl={rtl}
        value={content.responses}
        onChange={handleResponsesChange}
      />
    </div>
  );
};

ActionInput.propTypes = {
  rtl: PropTypes.oneOf(['rtl', 'ltr'])
};

export default ActionInput;
